import $ from 'jquery'

export default {
    name: 'manage-diagnosis',
    components: {},
    props: {
        consultation_id: Number,
        evolution_id: Number,
        user_id: Number,
        data_info: Object,
        group_id: Number,
        modal_toggler: Number,
        data_to_be_deleted: Object
    },
    data() {
        return {
            diagnosis: {
                diagnostic: null,
                hypotheses_diagnostiques: null
            },

            // +++++++++++++++++++++++++++++++++++++++
            del_loading: false,
            is_confirm: false,

            save_loading: false,
            is_error: false,
            permission_is_denied: false,
            diagnosis_is_empty: false,

            tmp_diagnosis: [],
            searched_diagnosis: [],
            v_diagnosis: ''
        }
    },

    watch: {
        modal_toggler() {
            this.permission_is_denied = false
            this.is_error = false
            this.searched_diagnosis = []
            this.v_diagnosis = ''
            this.tmp_diagnosis = []
            this.save_loading = false
        }
    },

    computed: {
        /**
         * Liste des diagnostics
         */
        listeDiagnostics() {
            return this.$store.getters["listeDiagnostics"];
        },
    },
    mounted() {
        this.refreshListeDiagnostics()
    },

    methods: {
        refreshListeDiagnostics() {
            this.$store.dispatch("getListeDiagnostics")
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        removeTmp(index) {
            this.tmp_diagnosis.splice(index, 1)
        },

        /**
         * Retirer Diagnostic/Hypothèse diagnostique
         */
        supprimer(selector) {
            let confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true
            console.log(this.data_to_be_deleted);

            this.$store.dispatch('removeDignostic', this.data_to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast(this.data_info.libelle+' supprimé(e) avec succès')
                    if (this.data_info.data_type === 'hypothese_diagnostique') {
                        this.$emit("emitHypothese")
                    } else {
                        this.$emit("emitDiagnostic")
                    }

                    this.$refs.del_diagnosis.click()
                } else {
                    if (response === -2) {
                        this.permission_is_denied = true
                    }
                }

                
                this.del_loading = false;
                this.is_confirm = false
            }).catch(() => {
                this.del_loading = false
                this.is_error = true
            })
        },

        deleteGroupDiagnosis(selector) {
            let confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true
            console.log(this.data_to_be_deleted);

            this.$store.dispatch('deleteDiagnosisGroup', this.data_to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast('Suppression effectuée avec succès')
                    if (this.data_info.data_type === 'hypothese_diagnostique') {
                        this.$emit("emitHypothese")
                    } else {
                        this.$emit("emitDiagnostic")
                    }

                    this.$refs.del_grp_diagnosis.click()
                } else {
                    if (response === -2) {
                        this.permission_is_denied = true
                    }
                }

                
                this.del_loading = false;
                this.is_confirm = false
            }).catch(() => {
                this.del_loading = false
                this.is_error = true
            })
        },

        filterHypothese() {
            this.diagnosis_is_empty = false
            this.searched_diagnosis = []

            if (this.v_diagnosis.length >= 2) {
                this.listeDiagnostics.forEach(
                    element => {
                        if (element.libelle.toLowerCase().includes(this.v_diagnosis.toLowerCase())) {
                            this.searched_diagnosis.push(element)
                        }
                    }
                )
            }
        },

        addDiagnosis(selected_hyp) {
            let j = 0;
            let len = this.tmp_diagnosis.length;

            let hyp = {}
            let is_diagnostic = this.data_info.is_diagnostic
            this.listeDiagnostics.forEach(function (el) {
                if (selected_hyp.libelle == el.libelle) {
                    hyp = {
                        diagnostic_id: el.id,
                        is_diagnostic: is_diagnostic,
                        libelle: el.libelle
                    }
                }
            });

            /** 
             * Vérifie diagnostic déjà choisi
            */
            if (len > 0) {
                for (let i = 0; i < this.tmp_diagnosis.length; i++) {
                    if (selected_hyp.libelle == this.tmp_diagnosis[i].libelle) {
                        j++;
                    }
                }

            }
            if (j == 0) {
                this.tmp_diagnosis.push(hyp);

                this.v_diagnosis = ''
                this.searched_diagnosis = []
            }
        },

        addDiagnosticIfNotExist(value) {
            let j = 0;
            let len = this.tmp_diagnosis.length;
            let hyp = {}

            hyp = {
                diagnostic_id: 0,
                is_diagnostic: this.data_info.is_diagnostic,
                libelle: value
            }

            /** 
             * Vérifie diagnostic déjà choisi
            */
            if (len > 0) {
                for (let i = 0; i < this.tmp_diagnosis.length; i++) {
                    if (this.v_diagnosis == this.tmp_diagnosis[i].libelle) {
                        j++;
                    }
                }

            }
            if (j == 0) {
                this.tmp_diagnosis.push(hyp);

                this.v_diagnosis = ''
                this.searched_diagnosis = []
            }
        },

        submitDiagnosis() {
            if (this.tmp_diagnosis.length == 0) {
                this.diagnosis_is_empty = true
                return
            }

            let data = {
                user_id: this.user_id,
                consultation_id: this.consultation_id,
                evolution_id: this.evolution_id,
                group_id: this.group_id,
                is_diagnostic: this.data_info.is_diagnostic,
                data_type: this.data_info.data_type,
                diagnosis: this.tmp_diagnosis
            }

            this.save_loading = true
            this.$store.dispatch('saveConsultationDiagnostic', data).then((response) => {
                if (response > 0) {
                    this.successToast(this.data_info.libelle+' ajouté(e) avec succès')
                    if (this.data_info.data_type === 'hypothese_diagnostique') {
                        this.$emit("emitHypothese")
                    } else {
                        this.$emit("emitDiagnostic")
                    }
                    
                    this.$refs.diagnosis_mdl.click()
                } else {
                    if (response === -1) {
                        this.is_error = true
                    } else if (response === -2) {
                        this.permission_is_denied = true
                    }
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
            })
        }
    }
}


